















import { Component, Vue, Watch } from 'vue-property-decorator';
import Cookie from 'js-cookie';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import Concierge from './components/Concierge.vue';
import { Translate } from '@/lang/Translator';

import * as log from 'loglevel';

log.setLevel(0);

@Component({
  components: {
    Concierge,
  },
})
export default class App extends Vue {
  private isShowApplication = false;
  private isCircleShown = false;
  private addApp = false;

  private langLoad = false;

  private wrapperDOMElement: HTMLElement | null;

  // add when concierge is open on the mobile version
  private classForBody: string = 'concierge-is-open';

  private windowWidth: number = 0;

  // wathers
  @Watch('isCircleShown')
  private change(val: boolean) {
    if (val === true) {
      Vue.nextTick(() => {
        this.wrapperDOMElement = document.getElementById('concierge-wrapper-js');
      });
    }

    Vue.nextTick()
      .then(() => {
        const scrollableElement = this.wrapperDOMElement;
        const isPortableScreen = (this.windowWidth < 1260);

        if (scrollableElement !== null && isPortableScreen) {
          if (val === true) {
            disableBodyScroll(scrollableElement);
          } else {
            enableBodyScroll(scrollableElement);
          }
        }
      });
  }

  // computed
  get t(): Translate {
    return this.$store.state.t;
  }

  private loadFile(url: string, type: string = 'script') {
    const domain = `https://${process.env.VUE_APP_SUBDOMAIN}.netwrix.com/`;
    return new Promise((res, rej) => {
      if (type === 'script') {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `${domain}${url}`;

        document.body.appendChild(script);
        script.onload = () => {
          res(script);
        };
      }

      if (type === 'css') {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `${domain}${url}`;

        document.head.appendChild(link);
        link.onload = () => {
          res(link);
        };
      }
    });
  }

  private loadChatApplication() {
    this.addApp = true;

    Vue.nextTick()
      .then(async () => {
        const chatlinkStyle = this.loadFile(`js/livechat/chat/css/app.css?v=1`, 'css');

        const chatVendors = await this.loadFile(`js/livechat/chat/js/chunk-vendors.js?v=1`);
        const chatApp = await this.loadFile(`js/livechat/chat/js/app.js?v=1`);

        if (this.wrapperDOMElement) {
          enableBodyScroll(this.wrapperDOMElement);
        }
        this.isShowApplication = false;
      });
  }

  private async loadLanguageUnit(language: string): Promise<void> {
    // get language-unit
    const t = new Translate(language);
    const result = await t.init();

    if (result) {
      this.$store.commit('setLanguageUnit', t);
      this.langLoad = true;
    }
  }

  private initResizeEvent(): void {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;

      if (this.windowWidth >= 1260 && this.wrapperDOMElement !== null) {
        enableBodyScroll(this.wrapperDOMElement);
      }
    });
  }

  private async created() {
    // show "circle" only on main page
    this.isCircleShown = window.location.pathname !== '/';

    const lang = 'en';

    this.initResizeEvent();
    await this.loadLanguageUnit(lang);
  }

  private mounted() {
    const googleAnalytics = window.ga || null;
    this.$store.commit('setGA', googleAnalytics);

    window.addEventListener('resize', () => {
      // We execute the same script as before
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  }
}
